import { combineReducers } from "redux";
import { authConstants } from "../action-constants/onboarding.constants";
import { outboundReducers, inAppReducers } from "./all-reducers";

const rootReducer = (state: any, action: any) => {
  if (action.type === authConstants.LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

const onboardingOutboundReducers = combineReducers({
  loginReducer: outboundReducers.loginReducer,
  forgotPasswordReducer: outboundReducers.forgotPasswordReducer,
});

const allInAppReducers = combineReducers({
  createStoreProductReducer: inAppReducers.createStoreProductReducer,
  uploadStoreBulkProductsReducer: inAppReducers.uploadStoreBulkProductsReducer,
  updateStoreProductReducer: inAppReducers.updateStoreProductReducer,
  getProductMetaDataReducer: inAppReducers.getProductMetaDataReducer,
  getAProductReducer: inAppReducers.getAProductReducer,
  getACustomerAddressReducer: inAppReducers.getACustomerAddressReducer,

  getImageGalleryReducer: inAppReducers.getImageGalleryReducer,
  uploadProductImageReducer: inAppReducers.uploadProductImageReducer,
  updateProductImageReducer: inAppReducers.updateProductImageReducer,
  getImageReducer: inAppReducers.getImageReducer,
  downloadImageReducer: inAppReducers.downloadImageReducer,
  deleteImageReducer: inAppReducers.deleteImageReducer,

  getStoresListReducer: inAppReducers.getStoresListReducer,
  getTopStoresReducer: inAppReducers.getTopStoresReducer,
  getOrderListReducer: inAppReducers.getOrderListReducer,
  getOrderDetailsReducer: inAppReducers.getOrderDetailsReducer,
  getProductsListReducer: inAppReducers.getProductsListReducer,
  getStoreDetailsReducer: inAppReducers.getStoreDetailsReducer,
  getStoreTransactionsReducer: inAppReducers.getStoreTransactionsReducer,
  updateStoreReducer: inAppReducers.updateStoreReducer,
  getCustomersReducer: inAppReducers.getCustomersReducer,
  getCustomersListReducer: inAppReducers.getCustomersListReducer,
  getVendorsReducer: inAppReducers.getVendorsReducer,
  getVendorDetailsReducer: inAppReducers.getVendorDetailsReducer,
  getCustomerDetailsReducer: inAppReducers.getCustomerDetailsReducer,
  updateCustomerReducer: inAppReducers.updateCustomerReducer,
  getCustomerOrdersReducer: inAppReducers.getCustomerOrdersReducer,
  getStoreChartReducer: inAppReducers.getStoreChartReducer,

  getDashboardSummaryReducer: inAppReducers.getDashboardSummaryReducer,
  getDashboardBottomOneReducer: inAppReducers.getDashboardBottomOneReducer,
  getDashboardBottomTwoReducer: inAppReducers.getDashboardBottomTwoReducer,
  getVendorSummaryReducer: inAppReducers.getVendorSummaryReducer,
  getProductsSummaryReducer: inAppReducers.getProductsSummaryReducer,

  toggleUserReducer: inAppReducers.toggleUserReducer,
  toggleStoreReducer: inAppReducers.toggleStoreReducer,

  addNewStoreReducer: inAppReducers.addNewStoreReducer,
  getStoreGroupsReducer: inAppReducers.getStoreGroupsReducer,
  getStoreGroupReducer: inAppReducers.getStoreGroupReducer,
  createStoreGroupReducer: inAppReducers.createStoreGroupReducer,
  updateStoreGroupReducer: inAppReducers.updateStoreGroupReducer,
  deleteStoreGroupReducer: inAppReducers.deleteStoreGroupReducer,
  getStoreCategoriesReducer: inAppReducers.getStoreCategoriesReducer,
  getStoreCategoryReducer: inAppReducers.getStoreCategoryReducer,
  createStoreCategoryReducer: inAppReducers.createStoreCategoryReducer,
  updateStoreCategoryReducer: inAppReducers.updateStoreCategoryReducer,
  deleteStoreCategoryReducer: inAppReducers.deleteStoreCategoryReducer,
  getUrlReducer: inAppReducers.getUrlReducer,
  updateVersionReducer: inAppReducers.updateVersionReducer,
  getVersionsReducer: inAppReducers.getVersionsReducer,
  createVersionReducer: inAppReducers.createVersionReducer
});

const appReducer = combineReducers({
  onboardingOutboundReducers,
  allInAppReducers,
});

export default rootReducer;
